/* Big Billion Days static copy. Everything else on the page (section copy,
   CTAs, spend progress, campaign end) comes from the API — see api.js and
   mockResponse.js. */

// TODO: one answer still carries a placeholder from the campaign team —
// the SuperCoin → Sats / gold conversion rate ([XX]).
export const FAQS = [
  {
    q: 'How do I earn 200 SuperCoins?',
    a: 'Complete four first-time actions on GoSats - your first card load, first voucher purchase, first credit card bill payment, and first gold purchase. Each one earns you 50 SuperCoins.',
  },
  {
    q: 'Do I have to complete all four?',
    a: 'No. Each action is rewarded on its own, so you earn 50 SuperCoins for every one you complete. Complete all four and you get the full 200.',
  },
  {
    q: 'Is there a minimum transaction value?',
    a: "Yes, ₹200 per transaction. Transactions below ₹200 won't qualify.",
  },
  {
    q: 'Who is eligible?',
    a: 'New GoSats users who come through Flipkart. Each action can be rewarded once per user, and the offer is limited to one account per person.',
  },
  {
    q: 'When will the SuperCoins be credited?',
    a: 'Credited within 48 hour of a successful transaction.',
  },
  {
    q: 'How long is the offer valid?',
    a: '1 October to 15 December 2026. All four actions must be completed within this window.',
  },
  {
    q: 'What is GoSats?',
    a: 'GoSats is an app that lets you convert SuperCoins into Bitcoin and digital gold, and offers a prepaid card you can load and spend.',
  },
  {
    q: 'What can I do with SuperCoins on GoSats?',
    a: 'Convert them into Bitcoin or digital gold, pay your credit card bill, buy vouchers, or pay utility bills.',
  },
  {
    q: 'What happens if my transaction is refunded or cancelled?',
    a: "SuperCoins are credited only on successfully completed transactions. If a transaction is reversed, the reward won't apply.",
  },
  {
    q: 'How does Spend & Unlock work?',
    a: 'Spend ₹10,000 on Flipkart using your GoSats card during the campaign and unlock a bonus of 50 SuperCoins as reward. Spends are cumulative across the full period.',
  },
  {
    q: 'What is the Flash 3% offer?',
    a: "A surprise window each day where you earn an extra 3% back on Flipkart spends - over and above your regular earn rate. Timing changes daily and isn't announced, so keep notifications on.",
  },
  {
    q: 'What do I earn on credit card and utility bill payments?',
    a: '0.5% back on credit card bill repayments and BBPS utility payments made through GoSats.',
  },
  {
    q: 'What do I get on gold purchases?',
    a: 'Flat 5% back in SuperCoins on gold purchases.',
  },
  {
    q: 'Where can I use my SuperCoins?',
    a: 'You can pay with SuperCoins across most of GoSats - up to 60% on vouchers, up to 60% on utility bills through BBPS, and up to 2% on your credit card bill payment. SuperCoins also cover 100% of a physical GoSats card and 100% of the card recharge surcharge.',
  },
  {
    q: 'How to earn 0.5% Supercoins on BBPS payments / Credit Card bill payments?',
    a: 'Pay your BBPS bills through GoSats and earn 0.5% Supercoins on the payment amount. The offer is valid for all BBPS services - credit card bill payments, electricity, gas, water, and more. Payments must be made through GoSats to qualify.',
  }
];
